import { FetchClientsResponseType } from './useSearchClients';

export interface ClientsDataType {
  key: React.Key;
  uuid: string;
  name: string;
}

export const useClientsTableDataSource = (data: FetchClientsResponseType | undefined): ClientsDataType[] => {
  if (!data) {
    return [];
  }

  const dataToMap = data?.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      uuid: element.uuid,
      name: element.name,
    };
  });
};
